import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'chevrons-left', 'IconChevronsLeft', [["path",{"d":"M11 7l-5 5l5 5","key":"svg-0"}],["path",{"d":"M17 7l-5 5l5 5","key":"svg-1"}]]);